import React from 'react';
import { Route, IndexRoute, useRouterHistory } from 'react-router';

import App from './components/App';
import Start from './components/Start';
import ConfiguratorPage from './containers/ConfiguratorPage';
import ResultPage from './containers/ResultPage';
import NotFoundPage from './components/NotFoundPage';

import { createHistory } from 'history';

const basepath = '/da_dk/showersystems/';

const history = useRouterHistory(createHistory)({
  basename: basepath
});

export default (
  <Route onChange={() => window.scrollTo(0,0)} history={history} path={basepath} component={App}>
    <IndexRoute component={Start}/>
    <Route path="configurator(/:reset)" component={ConfiguratorPage}/>
    <Route path="result" component={ResultPage}/>
    <Route path="*" component={NotFoundPage}/>
  </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js